<div class="container-fluid p-3">
  <div
    class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-4 flex-wrap">
    <!-- Title aligned to the right on larger screens -->
    <h4 class="m-0 text-md-end text-start text-color fs-24 fg-500">
      {{ 'ADMIN.THEMES' | translate }}
    </h4>

    <!-- Dropdowns and Add Button -->
    <div class="d-flex flex-column flex-sm-row gap-2 flex-wrap align-items-stretch align-items-sm-center">
      <!-- Learning Path Dropdown -->
      <select class="form-select" style="min-width: 180px;" [(ngModel)]="selectedPathId"
        (change)="onPathChange(selectedPathId!)" [disabled]="isLoadingPaths">
        <option [value]="null" disabled>{{ 'ADMIN.SELECT_PATH' | translate }}</option>
        <option *ngFor="let path of learningPaths" [value]="path.id">
          {{ path.title }}
        </option>
      </select>

      <!-- Subject Dropdown -->
      <select class="form-select" style="min-width: 180px;" [(ngModel)]="selectedSubjectId"
        (change)="onSubjectChange(selectedSubjectId!)"
        [disabled]="isLoadingSubjects || subjects.length === 0 || !selectedPathId">
        <option [value]="null" disabled>{{ 'ADMIN.SELECT_SUBJECT' | translate }}</option>
        <option *ngFor="let subject of subjects" [value]="subject.id">
          {{ subject.name }}
        </option>
      </select>

      <!-- Add Theme Button -->
      <app-button (click)="addTheme()" [label]="'ADMIN.ADD_THEME' | translate"
        [customClasses]="'fs-14 fg-600 py-2 px-5 btn-create-test'" [type]="'button'" />
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
    </div>
    <p class="mt-3">{{ 'COMMON.LOADING' | translate }}</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !isLoading" class="alert alert-danger" role="alert">
    <i class="fa-solid fa-circle-exclamation me-2"></i>
    {{ error }}
    <button type="button" class="btn btn-sm btn-outline-danger ms-3" (click)="loadThemes()">
      <i class="fa-solid fa-rotate-right me-1"></i>
      {{ 'COMMON.RETRY' | translate }}
    </button>
  </div>

  <!-- Data Table -->
  <app-custom-tab *ngIf="!isLoading && !error && themes.length > 0" [data]="themes" [columns]="themeColumns"
    [actionTemplate]="themeActionsTemplate" [locale]="currentLocale" [enableRtl]="isRTL"
    (rowClick)="handleRowClick($event)">

    <!-- Define the actions template here with stopPropagation -->
    <ng-template #themeActionsTemplate let-data>
      <button class="btn btn-sm btn-primary mx-1" (click)="onEditTheme(data); $event.stopPropagation()"
        [title]="'COMMON.EDIT' | translate">
        <i class="fa-solid fa-pen-to-square"></i>
      </button>
      <button class="btn btn-sm btn-danger mx-1" (click)="onDeleteTheme(data); $event.stopPropagation()"
        [title]="'COMMON.DELETE' | translate">
        <i class="fa-solid fa-trash-can"></i>
      </button>
      <button class="btn btn-sm btn-secondary mx-1" (click)="onShowTheme(data); $event.stopPropagation()"
        [title]="'COMMON.VIEW' | translate">
        <i class="fa-solid fa-eye"></i>
      </button>
    </ng-template>
  </app-custom-tab>

  <!-- Empty State -->
  <div *ngIf="!isLoading && !error && themes.length === 0 && selectedSubjectId" class="text-center py-5">
    <i class="fa-solid fa-folder-open fa-3x text-muted mb-3"></i>
    <p class="text-muted">{{ 'ADMIN.NO_THEMES_FOUND' | translate }}</p>
    <app-button (click)="addTheme()" [label]="'ADMIN.CREATE_FIRST_THEME' | translate"
      [customClasses]="'fs-14 fg-600 py-2 px-4 btn-create-test'" [type]="'button'" />
  </div>

  <!-- No Subject Selected State -->
  <div *ngIf="!isLoading && !selectedSubjectId && selectedPathId && subjects.length > 0" class="text-center py-5">
    <i class="fa-solid fa-circle-info fa-3x text-info mb-3"></i>
    <p class="text-muted">{{ 'ADMIN.SELECT_SUBJECT_TO_VIEW_THEMES' | translate }}</p>
  </div>

  <!-- No Path Selected State -->
  <div *ngIf="!isLoading && !selectedPathId && learningPaths.length > 0" class="text-center py-5">
    <i class="fa-solid fa-circle-info fa-3x text-info mb-3"></i>
    <p class="text-muted">{{ 'ADMIN.SELECT_PATH_TO_VIEW_THEMES' | translate }}</p>
  </div>
</div>

<!-- ADD/EDIT THEME MODAL -->
<app-modal [title]="(isEditMode ? 'ADMIN.EDIT_THEME' : 'ADMIN.ADD_THEME') | translate" [size]="'lg'"
  [show]="showThemeModal" [hasFooter]="false" (closed)="onModalClosed()">
  <app-add-theme [theme]="selectedTheme" [isEditMode]="isEditMode" [subjectId]="selectedSubjectId"
    (saved)="handleThemeSaved($event)" (cancelled)="onModalClosed()">
  </app-add-theme>
</app-modal>